import { Box, Typography } from '@mui/material'
interface Props {
  label: string
}

export const Header = ({ label }: Props) => {
  return (
    <Typography
      variant="h6"
      sx={{
        fontWeight: 600,
        color: theme => theme.palette.text.primary,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 2,
      }}
    >
      <Box
        sx={{
          width: 4,
          height: 24,
          backgroundColor: theme => theme.palette.primary.main,
          borderRadius: 1,
        }}
      />
      {label}
    </Typography>
  )
}

export default Header
